import PointsReceivedBackCard from "./PointsReceivedBackCard";

export default PointsReceivedBackCard;
